exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "a[href=\"https://www.froala.com/wysiwyg-editor?k=u\"] {\n    display: none !important;\n    position: absolute;\n    top: -99999999px;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/Exchange-NewsAdmin-Frontend/src/app/components/pages/page/create/create-page.component.css
// module id = ../../../../../src/app/components/pages/page/create/create-page.component.css
// module chunks = main